import { Typography } from '@navi/web-ui/lib/primitives';
import KeyValue from '../KeyValue';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { getAssignedToName } from '../../utils';

const ResolutionDetails = () => {
  const anomalyDetails = useSelector(
    (state: RootState) => state?.anomalyTracker?.anomalyDetails?.data
  );
  const userReferenceId = useSelector((state: RootState) => state?.common?.userData?.referenceId);

  const { resolution } = anomalyDetails || {};
  const { comment, name, by } = resolution || {};
  const isResolvedByYou = by === userReferenceId;

  return (
    <div>
      <Typography color="var(--grayscale-2)" variant="h3" className="mb-4 mt-5">
        Resolution
      </Typography>
      <KeyValue title="Resolved by" description={getAssignedToName(name, isResolvedByYou)} />
      <KeyValue title="Comments" description={comment} />
    </div>
  );
};

export default ResolutionDetails;
